import React, { useState, useEffect, Component } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import { AsyncPaginate } from 'react-select-async-paginate';
import "jspdf-autotable";

const RefundAnalysis = () => {
    const apiService = new LeaseApiService();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [tanentList, setTanentList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const ITEMS_PER_PAGE = 100

    const [formData, setFormData] = useState({
        property: "",
        unitNo: "",
        tanent: "",
    })

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    useEffect(() => {
        fetchDropdownData()
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,LRSearchCustomerName');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties)
            setTanentList(res?.data?.dropdowns?.CustomerName);

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            if (!formData?.property?.value?.value) {
                toast.warning("Select Property")
                setLoader(false)
                return
            } else if (!formData?.unitNo?.label) {
                toast.warning("Select Unit")
                setLoader(false)
                return
            } else if (!formData?.tanent?.value?.value) {
                toast.warning("Select Customer")
                setLoader(false)
                return
            }
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("UnitNo", formData?.unitNo?.label || "All");
            params.append("CustomerNo", formData?.tanent?.value?.value || "All");
            
            const res = await apiService.getApiParamater("REPORT_REFUND_ANALYSIS", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            setLoader(false)
            console.error("Error fetching items:", error);
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("UnitNo", formData?.unitNo?.label || "All");
            params.append("CustomerNo", formData?.tanent?.value?.value || "All");
            const res = await apiService.getApiParamater("REPORT_REFUND_ANALYSIS", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setExportData(result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            // Handle error (e.g., show error message to user)
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2)
            ? 0
            : momentDate1.isBefore(momentDate2)
                ? -1
                : 1;
    }
    const columnDefs = [
        { headerName: "Lease No", field: "leaseNo", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Period From", field: "leaseDate", valueFormatter: dateFormatter, comparator: dateComparator, filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        { headerName: "Period To", field: "leaseExpiry", valueFormatter: dateFormatter, comparator: dateComparator, filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        { headerName: "Type", field: "paymentType", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        {
            headerName: "Period", field: "dueDate", filter: true, floatingFilter: true, suppressMovable: true, width: 200,
            valueFormatter: (params) => {
                const LeaseDate = params?.data?.leaseDate
                const LeaseExpiry = params?.data?.leaseExpiry
                
                return (`${moment(LeaseDate).format("DD-MMM-YYYY")} _ ${moment(LeaseExpiry).format("DD-MMM-YYYY")}`);
            }
        },
        { headerName: "Amount Dr(INV)", field: "installmentAmount", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        { headerName: "Amount Cr", field: "amountPaid", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "SD .Adj", field: "adjAmount", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Receipt No", field: "receiptNo", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Balance", field: "balance", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
    ]
    const handleClearFilters = () => {
        const today = new Date();
        let todate = formatDate(today)
        setUnitList([])
        setFormData({
            property: "",
            movein: "Move In",
            unitNo: "",
            from: todate,
            to: todate,
            unitClass: "",
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null }));
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
            params.append('CascadValue', value?.value?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items)
        } else {
            const cusparams = new URLSearchParams();
            cusparams.append('DropdownFor', 'LRASearchCustByPropertyIdAndUnit');
            cusparams.append('CascadValue', formData?.property?.value?.value);
            cusparams.append('CascadText', value?.value?.value);
            const cusRes = await apiService.getApiParamater('REPORT_CASCAD', `?${cusparams.toString()}`);

        }
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const loadOptionsName = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return ""; // keep this if you want 0 to be empty

        // Check if value is a date string in ISO format
        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");

        const columns = [
            { header: "Lease No", dataKey: "LeaseNo", width: 100 },
            { header: "Period From", dataKey: "LeaseDate", width: 100 },
            { header: "Period To", dataKey: "LeaseExpiry", width: 100 },
            { header: "Type", dataKey: "PaymentType", width: 100 },
            { header: "Period", dataKey: "DueDate", width: 100 },
            { header: "Amount Dr(INV)", dataKey: "InstallmentAmount", width: 100 },
            { header: "Amount Cr", dataKey: "AmountPaid", width: 100 },
            { header: "SD .Adj", dataKey: "AdjAmount", width: 100 },
            { header: "Receipt No", dataKey: "ReceiptNo", width: 100 },
            { header: "Balance", dataKey: "Balance", width: 100 },
        ];

        /* ========= HEADER ========= */

        doc.setFillColor(110, 81, 153); // #6E5199
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Refund Analysis Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated unit: ${moment(formData?.to).format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        /* ========= TABLE ========= */
        doc.autoTable({
            startY: 60,
            head: [columns.map(col => col.header)],
            body: exportData.map(row =>
                columns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("Refund_Analysis_Report.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const columns = [
            { header: "Lease No", dataKey: "LeaseNo", width: 100 },
            { header: "Period From", dataKey: "LeaseDate", width: 100 },
            { header: "Period To", dataKey: "LeaseExpiry", width: 100 },
            { header: "Type", dataKey: "PaymentType", width: 100 },
            { header: "Period", dataKey: "DueDate", width: 100 },
            { header: "Amount Dr(INV)", dataKey: "InstallmentAmount", width: 100 },
            { header: "Amount Cr", dataKey: "AmountPaid", width: 100 },
            { header: "SD .Adj", dataKey: "AdjAmount", width: 100 },
            { header: "Receipt No", dataKey: "ReceiptNo", width: 100 },
            { header: "Balance", dataKey: "Balance", width: 100 },
        ];

        const excelData = exportData.map(item => {
            const row = {};
            columns.forEach(col => {
                row[col.header] = normalizeValue(item[col.dataKey]);
            });
            return row;
        });
        
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Refund Analysis Report");
        XLSX.writeFile(workbook, "Refund_Analysis_Report.xlsx");
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Customer</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tanent}
                                    loadOptions={loadOptionsName}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tanent", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div onClick={() => getItems()} className="mainbtnGry flex-end gap-2 w-50">
                                        <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50">
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-contant-between ">
                            <h5 className="col mainInvHead">Refund Analysis Report</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                Export as PDF
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>
                        <div className="gridshad  mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: "#F0EDF5" };
                                        } else {
                                            return { background: "#fff" };
                                        }
                                    }}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default RefundAnalysis;